export default "__VITE_ASSET__BCaUgZ$w__"